import { render, staticRenderFns } from "./part_5.vue?vue&type=template&id=6e724a2d&scoped=true&"
import script from "./part_5.vue?vue&type=script&lang=js&"
export * from "./part_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e724a2d",
  null
  
)

export default component.exports